import { usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

type Result = ModelHookResult<{
	isSunriseEnabled: boolean;
}>;

/**
 * @deprecated use useIsFullSunriseEnabled instead
 */
export const useIsSunriseEnabled = (): Result => {
	const { data } = usePetitionDetailsPageUserData();
	return {
		data: {
			isSunriseEnabled: data.isSunriseEnabled,
		},
	};
};
